import React from "react";

const PriceInput = ({
  value,
  background,
  textColor,
  readOnly,
  onChange,
  disable,
}: {
  value?: string;
  background?: string | boolean;
  textColor?: string | boolean;
  readOnly?: boolean;
  onChange?: (e: any) => void;
  disable?: boolean;
}) => {
  return (
    <>
      <input
        type="text"
        name="addBudget"
        className={`w-full h-10 mt-2 mb-3 font-medium text-left ${
          background ? `bg-${background} ` : `bg-transparent outline-none`
        } ${textColor && `text-${textColor}`} rounded outline-none px-14 border-pkc-secondary border-1`}
        value={value}
        readOnly={readOnly}
        onInput={onChange}
        required
        disabled={disable}
      />
      <span className="absolute left-0 pl-3 top-4">تومان</span>
    </>
  );
};

export default PriceInput;
